import { ReportIds } from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { ProductionReportConfig } from './production-reports.models';
import { buildReportVariables, PRODUCTION_REPORTS_DEFAULT_TEMPLATE } from './production-reports.config.shared';

export const PRODUCTION_MGA_PAID_REPORT: ProductionReportConfig = {
  id: ReportIds.mgaPaid,
  name: 'MGA Paid',
  description: 'MGA Paid',
  template: {
    ...PRODUCTION_REPORTS_DEFAULT_TEMPLATE,
    title: 'MGA Paid',
    subtitle: 'Leaders Bulletin',
  },
  columnConfig: {
    agency_name: { displayName: 'MGA', format: 'text', width: '30%' },
    premium: { displayName: 'Premium', format: 'currency', sumTotal: true, width: '200px' },
    count: { displayName: 'Count', format: 'decimal1', sumTotal: true, width: '150px' },
    ntp_name: { displayName: 'NTP', format: 'text' },
  },
  variables: buildReportVariables(ReportIds.mgaPaid),
};

export const PRODUCTION_PERSONAL_PAID_REPORT: ProductionReportConfig = {
  id: ReportIds.personalPaid,
  name: 'Personal Paid',
  description: 'Personal Paid report',
  template: {
    ...PRODUCTION_REPORTS_DEFAULT_TEMPLATE,
    title: 'Personal Paid Report',
  },
  columnConfig: {
    premium: { displayName: 'Premium', format: 'currency', sumTotal: true, width: '200px' },
    count: { displayName: 'Count', format: 'decimal1', sumTotal: true, width: '150px' },
  },
  variables: buildReportVariables(ReportIds.personalPaid),
};

export const PRODUCTION_RMD_PAID_REPORT: ProductionReportConfig = {
  id: ReportIds.rmdPaid,
  name: 'RMD Paid',
  description: 'RMD Paid report',
  template: {
    ...PRODUCTION_REPORTS_DEFAULT_TEMPLATE,
    title: 'RMD Paid Report',
  },
  columnConfig: {
    premium: { displayName: 'Premium', format: 'currency', sumTotal: true, width: '200px' },
    count: { displayName: 'Count', format: 'decimal1', sumTotal: true, width: '150px' },
  },
  variables: buildReportVariables(ReportIds.rmdPaid),
};
